import { VIEW_MODES } from './types';

export const getViewAndMode = viewFromConfig => {
    viewFromConfig = viewFromConfig.toUpperCase();

    let view, mode;

    if (viewFromConfig.indexOf('ICON') !== -1) {
        view = viewFromConfig.replace('ICON', '');
        mode = VIEW_MODES.MINIMIZED;
    } else if (viewFromConfig.indexOf('POPUP') !== -1) {
        view = viewFromConfig.replace('POPUP', '');
        mode = VIEW_MODES.POPUP;
    } else if (viewFromConfig.indexOf('EIP') !== -1) {
        view = viewFromConfig.replace('EIP', '');
        mode = VIEW_MODES.POPUP;
    } else {
        view = viewFromConfig;
        mode = VIEW_MODES.MAXIMIZED;
    }

    return { view, mode };
};
